import type { ReactNode } from "react";
import { PageHeader } from "./PageHeader";

export type PageProps = {
  title?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
};

/** A screen: the header, then its content, filling the shell's content column. */
export function Page({ title, action, children }: PageProps) {
  return (
    <div className="mx-auto flex w-full flex-col gap-6">
      {title || action ? <PageHeader title={title} actions={action} /> : null}
      {children}
    </div>
  );
}
